import React, { useState } from 'react';

const HeightWeightStep = ({ question, value, onAnswer, onNext }) => {
  const [feet, setFeet] = useState(value?.feet || '');
  const [inches, setInches] = useState(value?.inches || '');
  const [weight, setWeight] = useState(value?.weight || '');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!feet || !inches || !weight) {
      setError('Please fill in all fields');
      return;
    }

    if (Number(feet) < 3 || Number(feet) > 8) {
      setError('Please enter a valid height');
      return;
    }

    if (Number(weight) < 50 || Number(weight) > 700) {
      setError('Please enter a valid weight');
      return;
    }

    onAnswer({ feet, inches, weight });
    onNext();
  };

  return (
    <div data-testid={`step-${question.id}`}>
      {/* Question */}
      <h2 className="text-2xl md:text-3xl font-semibold text-center text-gray-900 mb-2">
        {question.question}
      </h2>

      {/* Subtitle */}
      {question.subtitle && (
        <p className="text-center text-gray-500 mb-8">
          {question.subtitle}
        </p>
      )}

      {/* Form */}
      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Height */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Height</label>
          <div className="flex gap-3">
            <div className="flex-1">
              <div className="relative">
                <input
                  type="number"
                  value={feet}
                  onChange={(e) => { setFeet(e.target.value); setError(''); }}
                  placeholder="5"
                  className="form-input text-center pr-12"
                  min="3"
                  max="8"
                  data-testid="feet-input"
                />
                <span className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500">ft</span>
              </div>
            </div>
            <div className="flex-1">
              <div className="relative">
                <input
                  type="number"
                  value={inches}
                  onChange={(e) => { setInches(e.target.value); setError(''); }}
                  placeholder="8"
                  className="form-input text-center pr-12"
                  min="0"
                  max="11"
                  data-testid="inches-input"
                />
                <span className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500">in</span>
              </div>
            </div>
          </div>
        </div>

        {/* Weight */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Current Weight</label>
          <div className="relative">
            <input
              type="number"
              value={weight}
              onChange={(e) => { setWeight(e.target.value); setError(''); }}
              placeholder="180"
              className="form-input text-center pr-12"
              min="50"
              max="700"
              data-testid="weight-input"
            />
            <span className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500">lbs</span>
          </div>
        </div>

        {error && (
          <p className="text-center text-red-500 text-sm" data-testid="error-message">
            {error}
          </p>
        )}

        <button
          type="submit"
          className="btn-primary"
          data-testid="continue-button"
        >
          Continue
        </button>
      </form>
    </div>
  );
};

export default HeightWeightStep;
